<template>
    <div>
        <div class="section">
            <!-- container -->
            <div class="container">
                <!-- row -->
                <div class="row">
                    <!-- ASIDE -->
                    <div id="aside" class="col-md-3">
                        <!-- aside Widget -->
                        <div class="aside">
                            <h3 class="aside-title">Categorias</h3>
                            <div class="checkbox-filter">
                                <div class="input-checkbox">
                                    <router-link :to="'/produtos/' + 999999 + '/linha-completa'">
                                        <input type="checkbox" id="category-1">
                                        <label for="category-1" style="font-size: 13px;color: #2B2D42;font-weight: 500;">
                                            <span></span>
                                            LINHA COMPLETA
                                        </label>
                                    </router-link>
                                </div>
                                <div class="input-checkbox" v-for="segmento in MenuSegmentos"
                                    :key="segmento.segmentoProdNivel1Id">
                                    <router-link :to="'/produtos/' + segmento.segmentoProdNivel1Id + '/' + segmento.nomeSegmento.replaceAll(' ', '-').replaceAll('/', '')">
                                        <input type="checkbox" id="category-1" v-if="segmento.segmentoProdNivel1Id != segmentoProdNivel1Id">
                                        <input type="checkbox" id="category-1" v-else checked>
                                        <label for="category-1" style="font-size: 13px;color: #2B2D42;font-weight: 500;">
                                            <span></span>
                                            {{ segmento.nomeSegmento }}
                                        </label>
                                    </router-link>
                                </div>

                            </div>
                        </div>
                        <!-- /aside Widget -->
                    </div>
                    <!-- /ASIDE -->
                    <!-- STORE -->
                    <div id="store" class="col-md-9">
                        <!-- store top filter -->
                        <div class="store-filter clearfix">
                            <div class="store-sort" style="width: 100%;">
                                <v-select v-model="Segmento2selected" @input="MudaSegmento2" v-if="Segmentos2 != ''"
                                    style="position:relative;z-index:99999999;float:left;width:400px;padding-bottom: 20px;" :options="Segmentos2"
                                    :reduce="nomeSegmento => nomeSegmento.segmentoProdNivel2Id" single-line
                                    label="nomeSegmento" class="style-chooser">
                                </v-select>
                                <v-select v-model="Ordemselected" @input="MudaOrdem"
                                    style="position:relative;z-index:99999999;float:right;width:200px;" :options="Ordenar"
                                    :reduce="nome => nome.valor" single-line label="nome" class="style-chooser">
                                </v-select>
                            </div>
                        </div>
                        <!-- /store top filter -->
                        <!-- store products -->
                        <div class="row">
                            <!-- product -->
                            <h3 v-if="SegmentoClicado!=''" class="aside-title">{{ SegmentoClicado[0].nomeSegmento }}</h3>
                            <div class="col-md-4 col-xs-6" v-for="itemProd in Produtos" :key="itemProd.produtoId">
                                <div class="product">
                                    <router-link
                                        :to="'/produtoDetalhe/' + itemProd.produtoId + '/' + itemProd.nomeProduto.replaceAll(' ', '-').replaceAll('/', '').replaceAll('+', '')">
                                        <div class="product-img">
                                            <img v-if="itemProd.imagens!=''" :src="$Url + itemProd.imagens[0].urlImg" alt="">
                                            <div class="product-label" v-if="itemProd.etiqueta != null">
                                                <span class="new"
                                                    :style="{ backGroundColor: itemProd.etiquetaCorFundo, color: itemProd.etiquetaCorFonte }">{{
                                                        itemProd.etiqueta }}</span>
                                            </div>
                                        </div>
                                    </router-link>
                                    <div class="product-body">
                                        <p class="product-category">Caixas de Transmissão</p>
                                        <h3 class="product-name">
                                            <router-link
                                                :to="'/produtoDetalhe/' + itemProd.produtoId + '/' + itemProd.nomeProduto.replaceAll(' ', '-').replaceAll('/', '').replaceAll('+', '')"
                                                style="font-size: 14px;color: #2B2D42;font-weight: 500;">
                                                {{ itemProd.nomeProduto }}
                                            </router-link>
                                        </h3>
                                    </div>
                                    <div class="add-to-cart">
                                        <!--button
                                            @click="$redirect_reload('/produtoDetalhe/' + itemProd.produtoId + '/' + itemProd.nomeProduto.replaceAll(' ', '-').replaceAll('/', '').replaceAll('+', ''))"
                                            class="add-to-cart-btn"><i class="fa fa-angle-right"></i> +
                                            Detalhes</!--button-->
                                            <button
                                                @click="navigateToProduct(itemProd)"
                                                class="add-to-cart-btn"
                                                >
                                                <i class="fa fa-angle-right"></i> + Detalhes
                                                </button>
                                    </div>
                                </div>
                            </div>
                            <!-- /product -->
                        </div>
                        <!-- /store products -->
                    </div>
                    <!-- /STORE -->
                </div>
                <!-- /row -->
            </div>
            <!-- /container -->
        </div>
        <!-- /SECTION -->
    </div>
</template>

<script>
//import vSelect from 'vue-select';
import { VMoney } from 'v-money'

export default {
    components: {
        // vSelect,
    },
    data() {
        return {
            segmentoProdNivel1Id: this.$route.params.id,
            nomeSegmento: this.$route.params.segmento,
            TextoBusca: this.$route.params.texto,
            MenuSegmentos: [],
            MenuSegmento: {},

            ProdutosGerais: [],
            Produtos: [],
            NomeSegmentoFilho: '',
            Ordemselected: 'Ordenar por',
            Ordenar: [
                {
                    nome: "A-Z",
                    valor: 3
                },
                {
                    nome: "Z-A",
                    valor: 4
                }
            ],
            Segmento2selected: 'Filtrar Por',
            Segmentos2: [],
            bg_imagem: '',
            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                masked: true
            },
            fundotela: '',
            SegmentoClicado: {},
            SubSegmentoClicado: '',
        }
    },
    directives: { money: VMoney },
    methods: {
        navigateToProduct(itemProd) {
            const path = `/produtoDetalhe/${itemProd.produtoId}/${itemProd.nomeProduto
            .replaceAll(' ', '-')
            .replaceAll('/', '')
            .replaceAll('+', '')}`;
            
            this.$router.push(path);
        },
        MudaOrdem() {
            if (this.Ordemselected == 3) {
                this.Produtos.sort(function (a, b) {
                    if (a.nomeProduto > b.nomeProduto) {
                        return 1;
                    }
                    if (a.nomeProduto < b.nomeProduto) {
                        return -1;
                    }
                    return 0;
                });
            } else if (this.Ordemselected == 4) {
                this.Produtos.sort(function (a, b) {
                    if (a.nomeProduto > b.nomeProduto) {
                        return 1;
                    }
                    if (a.nomeProduto < b.nomeProduto) {
                        return -1;
                    }
                    return 0;
                }).reverse();
            } else {
                this.Produtos.sort(function (a, b) {
                    if (a.segmentos[0].ordem > b.segmentos[0].ordem) {
                        return 1;
                    }
                    if (a.segmentos[0].ordem < b.segmentos[0].ordem) {
                        return -1;
                    }
                    return 0;
                }).reverse();
            }

        },
        MudaSegmento2() {
            if (this.Segmento2selected != null) {
                this.$http
                    .get(this.$apiUrl + "/Produto/segmentoprodnivel2/" + this.Segmento2selected)
                    .then((res2) => res2.json())
                    .then((tiu2) => {
                        this.ProdutosGerais = tiu2.filter(x => x.visivel).sort(function (a, b) {
                            if (a.segmentos[0].ordem > b.segmentos[0].ordem) {
                                return 1;
                            }
                            if (a.segmentos[0].ordem < b.segmentos[0].ordem) {
                                return -1;
                            }
                            return 0;
                        });
                        this.Produtos = this.ProdutosGerais;
                    });
            }
            else {
                this.$http
                    .get(this.$apiUrl + "/Produto/segmentoprodnivel1/" + this.segmentoProdNivel1Id)
                    .then((res2) => res2.json())
                    .then((tiu2) => {
                        this.ProdutosGerais = tiu2.filter(x => x.visivel).sort(function (a, b) {
                            if (a.segmentos[0].ordem > b.segmentos[0].ordem) {
                                return 1;
                            }
                            if (a.segmentos[0].ordem < b.segmentos[0].ordem) {
                                return -1;
                            }
                            return 0;
                        });
                        this.Produtos = this.ProdutosGerais;
                    });
            }
        },
    },
    created() {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
        this.$http
            .get(this.$apiUrl + "/SegmentoProdNivel1/")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.MenuSegmentos = tiu2.filter(x => x.visivel).sort(function (a, b) {
                    if (a.nomeSegmento > b.nomeSegmento) {
                        return 1;
                    }
                    if (a.nomeSegmento < b.nomeSegmento) {
                        return -1;
                    }
                    return 0;
                });

                this.SegmentoClicado = this.MenuSegmentos.filter(x => x.segmentoProdNivel1Id == this.segmentoProdNivel1Id)
            });

            this.$http
                .get(this.$apiUrl + "/SegmentoProdNivel2")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.Segmentos2 = tiu2.filter(x => x.visivel && x.segmentoProdNivel1.segmentoProdNivel1Id == this.segmentoProdNivel1Id)
                });

        if (typeof this.TextoBusca != 'undefined') {
            console.log("aqui")
            let _texto = this.TextoBusca.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          
            this.$http
                .get(this.$apiUrl + "/produto")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.ProdutosGerais = tiu2.filter(x => x.visivel && x.nomeProduto != null) ;
                    console.log("this.ProdutosGerais")
                     console.log(this.ProdutosGerais)
                    this.Produtos = this.ProdutosGerais.filter(x => x.nomeProduto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_texto.toLowerCase()) != -1 
                                                               || (x.resuno != null && x.resuno != "" && x.resuno.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_texto.toLowerCase()) != -1)
                                                               || (x.descricao != null && x.descricao != "" && x.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(_texto.toLowerCase()) != -1));                
                
                    this.Produtos.forEach(registro => {
                        registro.imagens.sort((a, b) => a.ordem - b.ordem);
                    });                                   
                 });
        }
        else if (this.segmentoProdNivel1Id == 999999){
            this.$http
                .get(this.$apiUrl + "/Produto/")
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.ProdutosGerais = tiu2.filter(x => x.visivel).sort(function (a, b) {
                        if (a.tempoProducao > b.tempoProducao) {
                            return 1;
                        }
                        if (a.tempoProducao < b.tempoProducao) {
                            return -1;
                        }
                        return 0;
                    });
                    this.Produtos = this.ProdutosGerais;
                    this.Produtos.forEach(registro => {
                        registro.imagens.sort((a, b) => a.ordem - b.ordem);
                    });         
                });
        }
        else {
            this.$http
                .get(this.$apiUrl + "/Produto/segmentoprodnivel1/" + this.segmentoProdNivel1Id)
                .then((res2) => res2.json())
                .then((tiu2) => {
                    this.ProdutosGerais = tiu2.filter(x => x.visivel).sort(function (a, b) {
                        if (a.segmentos[0].ordem > b.segmentos[0].ordem) {
                            return 1;
                        }
                        if (a.segmentos[0].ordem < b.segmentos[0].ordem) {
                            return -1;
                        }
                        return 0;
                    });
                    this.Produtos = this.ProdutosGerais;
                    this.Produtos.forEach(registro => {
                        registro.imagens.sort((a, b) => a.ordem - b.ordem);
                    });         
                });
        }


    },
    mounted() {

    },
}

</script>

<style scoped>
@import '/css/produtos.css';

ul {
    padding-left: unset;
}

.form-control-sidebar {
    max-width: 80%;
}


.product_item {
    width: 100%;
    /*        background: #FFFFFF;
        box-shadow: 6px 4px 8px #ccc;*/
    padding-top: 130px;
    padding-bottom: 230px;
    transition: all .2s ease-in;
}

/*        .product_item:hover {
            box-shadow: 10px 10px 8px #ccc;
        }*/


.vfigure {
    position: absolute;
    float: left;
    top: 20px;
    height: 40px;
    z-index: 999;
    text-align: center;
}


/********************
    Responsive
    ********************/

/* Smartphones */
@media (max-width:767px) {
    .product_item {
        left: 0px;
    }

    .shop_sorting {
        float: initial;
    }

    .shop {
        background: #FFFFFF;
        padding-top: 20px;
        padding-bottom: 139px;
    }

    .vfigure {
        position: absolute;
        float: left;
        top: 65px;
        height: 40px;
        z-index: 999;
        text-align: center;
    }
}

/* Tudo, menos desktop */
@media (max-width:1199px) {
    .product_item {
        height: min-content;
        padding-top: 60px;
        padding-bottom: 80px;
    }

    .product_price {
        margin-top: 0px;
    }
}

.img-item {
    /*border-radius: 5px;*/
    /*   box-shadow: 1px 1px 10px #303030; */
    height: 260px;
}

.content {
    padding: 10px 5px 10px 5px;
}

/* Smartphones */
@media (max-width:767px) {
    .content {
        padding: 30px 10px 50px 10px;
    }
}

.vsa-item__trigger:focus,
.vsa-item__trigger:hover {
    outline: none;
    background-color: #5423c6 !important;
    color: var(--vsa-bg-color);
}

.card-header {
    padding: 0.5rem 0rem !important;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}</style>



